import { IDeviceInfo } from 'shared/domain/valueObjects';

export default function mapDeviceInfoToAPI(device: IDeviceInfo) {
  return {
    nomeNavegador: device.browser,
    versao: device.fullVersion,
    versaoPrincipal: device.version,
    agent: device.agent,
    ip: device.ip,
    session_id: device.sessionId,
  };
}
